import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SgRadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'ptl-sg-radio-group',
  templateUrl: './sg-radio-group.component.html',
  styleUrls: ['./sg-radio-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SgRadioGroupComponent),
      multi: true,
    },
  ],
})
export class SgRadioGroupComponent implements ControlValueAccessor {
  @Input() options: SgRadioOption[] = [];
  @Input() disabled = false;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() name = 'radio-group';

  @Output() selectionChange = new EventEmitter<string>();

  value = '';

  private onChange = (value: string) => {
    // ControlValueAccessor callback
  };
  private onTouched = () => {
    // ControlValueAccessor callback
  };

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectionChange(value: string): void {
    this.value = value;
    this.onChange(this.value);
    this.selectionChange.emit(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
